
(function () {
  'use strict';

  const SEL = {
    upsellWidget: '[data-upsell-widget]',
    upsellProducts: '[data-upsell-products]',
    collapsibleBody: '[data-collapsible-body]',
    quickAddHolder: '[data-quick-add-holder]',
    cartDrawer: 'cart-drawer'
  };
  const ITEM_ATTR = 'data-complementary-item';
  const HIDDEN_CLASS = 'is-hidden';
  const AUTO_OPEN_ATTR = 'data-upsell-auto-open';

  function log() {
    // Verbose level — hidden in the console by default; enable "Verbose"/"All levels" to see it.
    try { console.debug.apply(console, ['[cart-complementary]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  class CartComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.widget = this.closest(SEL.upsellWidget);
      this.holder = this.widget ? this.widget.querySelector(SEL.upsellProducts) : null;
      this.recUrl = this.getAttribute('data-recommendations-url');
      this.sectionId = this.getAttribute('data-section-id') || 'api-cart-complementary';
      this.limit = parseInt(this.getAttribute('data-limit'), 10) || 4;
      this.token = 0;
      log('connected', { hasHolder: !!this.holder, recUrl: this.recUrl, inDrawer: !!this.closest(SEL.cartDrawer) });
      if (!this.holder || !this.recUrl) return;

      this.refresh = this.refresh.bind(this);
      this.boundEvents = ['theme:cart:refresh', 'theme:cart-drawer:open'];
      this.boundEvents.forEach((evt) => document.addEventListener(evt, this.refresh));
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.holder, { childList: true });

      const designMode = window.Shopify && window.Shopify.designMode;
      if (!this.closest(SEL.cartDrawer) || designMode) this.refresh();
    }

    disconnectedCallback() {
      if (this.boundEvents) this.boundEvents.forEach((evt) => document.removeEventListener(evt, this.refresh));
      if (this.observer) this.observer.disconnect();
      clearTimeout(this._t);
    }

    refresh() {
      clearTimeout(this._t);
      this._t = setTimeout(() => this.run(), 80);
    }

    mutate(fn) {
      if (this.observer) this.observer.disconnect();
      try { fn(); } finally {
        if (this.observer) { this.observer.takeRecords(); this.observer.observe(this.holder, { childList: true }); }
      }
    }

    block() { return this.holder.querySelector('[' + ITEM_ATTR + ']'); }
    hasMetafieldUpsells() { return Array.from(this.holder.children).some((el) => !el.hasAttribute(ITEM_ATTR)); }
    hasCards() { return this.holder.querySelectorAll(SEL.quickAddHolder).length > 0; }
    clearBlock() { const b = this.block(); if (b) this.mutate(() => b.remove()); }

    run() {
      if (!this.holder) return;
      if (this.hasMetafieldUpsells()) { log('metafield upsells present → skip'); this.clearBlock(); this.reveal(); return; }
      const token = ++this.token;

      this.getCartProductIds()
        .then((productIds) => {
          if (token !== this.token) return;
          log('cart product ids', productIds);
          if (!productIds.length) { this.clearBlock(); this._key = null; this.reveal(); return; }
          const key = productIds.join(',');
          if (this._key === key && this.block() && this.hasCards()) { this.reveal(); return; }

          return this.fetchCards(productIds[0], 'complementary', token)
            .then((html) => {
              if (token !== this.token) return null;
              if (html) return html;
              log('complementary empty → trying related');
              return this.fetchCards(productIds[0], 'related', token);
            })
            .then((html) => {
              if (token !== this.token) return;
              if (this.hasMetafieldUpsells()) { this.clearBlock(); this.reveal(); return; }
              this.clearBlock();
              if (html) {
                this.mutate(() => this.holder.insertAdjacentHTML('beforeend',
                  '<div class="complementary-products" ' + ITEM_ATTR + '>' + html + '</div>'));
                this._key = key;
                log('rendered carousel for product', productIds[0]);
              } else {
                this._key = null;
                log('no complementary or related products available');
              }
              this.reveal();
            });
        })
        .catch((e) => { log('run failed', e); });
    }

    getCartProductIds() {
      const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const ids = [];
          (cart.items || []).forEach((item) => {
            const id = String(item.product_id);
            if (!ids.includes(id)) ids.push(id);
          });
          return ids;
        });
    }

    // Returns the inner HTML of the response's <complementary-products> (a <slider-component>
    // with cards) when it has at least one card, otherwise null.
    fetchCards(productId, intent, token) {
      const url = this.recUrl + '?section_id=' + encodeURIComponent(this.sectionId) +
        '&product_id=' + encodeURIComponent(productId) + '&intent=' + intent + '&limit=' + this.limit;
      return fetch(url)
        .then((r) => r.text())
        .then((text) => {
          if (token !== this.token) return null;
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const cp = doc.querySelector('complementary-products');
          if (!cp || !cp.querySelector(SEL.quickAddHolder)) { log('no cards in response for', intent); return null; }
          return cp.innerHTML.trim();
        })
        .catch((e) => { log('fetch failed for', intent, e); return null; });
    }

    reveal() {
      if (!this.widget) return;
      const show = this.hasCards();
      this.widget.classList.toggle(HIDDEN_CLASS, !show);
      if (show && !this.widget.hasAttribute('open') && this.widget.hasAttribute(AUTO_OPEN_ATTR)) {
        this.widget.setAttribute('open', 'true');
        const body = this.widget.querySelector(SEL.collapsibleBody);
        if (body) body.style.height = 'auto';
      }
      log('reveal', { show: show });
    }
  }

  if (!customElements.get('cart-complementary-products')) {
    customElements.define('cart-complementary-products', CartComplementaryProducts);
  }
})();
